import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";

function Contactus(props) {
  const [isEmpty, setIsEmpty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [addresses, setAddresses] = useState([
    {
      title: "",
      address: "",
    },
  ]);
  const [enquiryOptions, setEnquiryOptions] = useState([""]);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const allFields = watch();
  const user = useSelector((state) => state.User);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // console.log("user", user);

  // get faqs
  const getPrivacy = () => {
    setIsLoading(true);
    apiReq(url.GET_CONTACTUS, {}, "get", null)
      .then((res) => {
        if (res.success && res.data !== null) {
          setValue("title", res.data.title);
          setValue("heading", res.data.heading);
          setValue("meta_title", res.data.meta_title);
          setValue("meta_description", res.data.meta_description);
          setAddresses(res.data.addresses);
          setEnquiryOptions(res.data.enquiryOptions);
          setIsEmpty(false);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          setIsEmpty(true);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getPrivacy();
  }, []);

  // console.log("isEmpty", enquiryOptions);

  // Todo: Create contactus page
  const createContactUs = (data) => {
    if (isEmpty) {
      setIsLoading(true);
      apiReq(
        url.CREATE_CONTACTUS,
        {
          title: data.title,
          heading: data.heading,
          addresses: addresses,
          enquiryOptions: enquiryOptions,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_CONTACTUS,
        {
          title: data.title,
          heading: data.heading,
          addresses: addresses,
          enquiryOptions: enquiryOptions,
          meta_title: data.meta_title,
          meta_description: data.meta_description,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  //Todo: addNewAddress
  const addNewAddress = () => {
    setAddresses([...addresses, { title: "", address: "" }]);
  };

  // Todo: handleAddress
  const handleAddress = (e, index) => {
    const { name, value } = e.target;
    const newAddresses = [...addresses];
    newAddresses[index][name] = value;
    setAddresses(newAddresses);
  };

  // Todo: Remove address
  const removeAddress = (index) => {
    const newAddresses = [...addresses];
    newAddresses.splice(index, 1);
    setAddresses(newAddresses);
  };

  // Todo: addNewOption
  const addNewOption = () => {
    setEnquiryOptions([...enquiryOptions, ""]);
  };

  //Todo: handleOption
  const handleOption = (e, index) => {
    const { name, value } = e.target;
    const newEnquiryOptions = [...enquiryOptions];
    newEnquiryOptions[index] = value;
    setEnquiryOptions(newEnquiryOptions);
  };

  // Todo: removeOption
  const removeOption = (index) => {
    const newEnquiryOptions = [...enquiryOptions];
    newEnquiryOptions.splice(index, 1);
    setEnquiryOptions(newEnquiryOptions);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {isLoading && <Loading />}
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Contact Us Page</h5>
              <hr />
              <form onSubmit={handleSubmit(createContactUs)}>
                <div className="mt-4">
                  <div className="mb-3">
                    <label>
                      Title{" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.title?.length} / 20)
                      </small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("title", { required: true })}
                      placeholder="Enter title"
                    />
                    {errors.title && (
                      <span className="text-danger">Title is required</span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label>
                      Heading(H1){" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.heading?.length} / 35)
                      </small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("heading", { required: true })}
                      placeholder="Enter heading"
                    />
                    {errors.heading && (
                      <span className="text-danger">Heading is required</span>
                    )}
                  </div>
                </div>
                <hr />
                <h4>Addresses</h4>
                {addresses.map((address, index) => {
                  return (
                    <div className="row mb-3" key={index}>
                      <div className="col-md-11">
                        <div className="row">
                          <div className="col-sm-6">
                            <input
                              type="text"
                              className="form-control"
                              name="title"
                              value={address.title}
                              placeholder="Enter address title"
                              onChange={(e) => handleAddress(e, index)}
                            />
                          </div>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              className="form-control"
                              name="address"
                              value={address.address}
                              placeholder="Enter address"
                              onChange={(e) => handleAddress(e, index)}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-1">
                        <button
                          className="btn btn-danger"
                          style={{ width: "100%" }}
                          type="button"
                          onClick={() => removeAddress(index)}
                        >
                          <i className="ri-delete-bin-line"></i>
                        </button>
                      </div>
                    </div>
                  );
                })}
                <div className="mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={addNewAddress}
                  >
                    <i className="ri-add-fill"></i> Add New Address
                  </button>
                </div>
                <hr />
                <h4>Enquiry Options</h4>
                {enquiryOptions.map((enquiryOption, index) => {
                  return (
                    <div className="row mb-3" key={index}>
                      <div className="col-md-11">
                        <input
                          type="text"
                          className="form-control"
                          name="enquiryOption"
                          value={enquiryOption}
                          placeholder="Enter option"
                          onChange={(e) => handleOption(e, index)}
                        />
                      </div>
                      <div className="col-md-1">
                        <button
                          className="btn btn-danger"
                          style={{ width: "100%" }}
                          type="button"
                          onClick={() => removeOption(index)}
                        >
                          <i className="ri-delete-bin-line"></i>
                        </button>
                      </div>
                    </div>
                  );
                })}
                <div className="mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-success"
                    type="button"
                    onClick={addNewOption}
                  >
                    <i className="ri-add-fill"></i> Add New Option
                  </button>
                </div>
                <h5 className="mt-4">SEO Meta Tags</h5>
                <hr />
                <div className="mb-3">
                  <label>
                    Meta Title{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_title?.length} / 70)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_title", { required: false })}
                    placeholder="Enter title"
                  />
                </div>
                <div className="mb-3">
                  <label>
                    Meta Description{" "}
                    <small className="text-muted" style={{ opacity: 0.5 }}>
                      ({allFields?.meta_description?.length} / 200)
                    </small>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    {...register("meta_description", { required: false })}
                    placeholder="Enter description"
                  />
                </div>
                <hr />
                <div>
                  <button className="btn btn-primary" type="submit">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Contactus;
